import { Box, Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAnalyticsConsent } from "../../features/analyticsConsent/AnalyticsConsentContext";

export function ConsentBanner() {
  const { setConsent } = useAnalyticsConsent();
  const { t } = useTranslation();

  return (
    <Box
      component="aside"
      role="dialog"
      aria-label={t("consent.title")}
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 1300,
        px: { xs: 2, sm: 3 },
        py: 2,
        background:
          "linear-gradient(180deg, rgba(255,255,255,0.98), rgba(255,255,255,0.96))",
        backdropFilter: "blur(12px)",
        borderTop: "1px solid rgba(28, 65, 106, 0.12)",
        boxShadow: "0 -4px 24px rgba(0,0,0,0.06)",
      }}
    >
      <Stack
        direction={{ xs: "column", sm: "row" }}
        alignItems={{ xs: "stretch", sm: "center" }}
        justifyContent="space-between"
        spacing={2}
        sx={{ maxWidth: 960, mx: "auto" }}
      >
        <Typography
          variant="body1"
          sx={{
            color: "#1C416A",
            flex: { sm: 1 },
            pr: { sm: 2 },
          }}
        >
          {t("consent.message")}
        </Typography>
        <Stack direction="row" spacing={1.5} sx={{ flexShrink: 0 }}>
          <Button
            variant="outlined"
            onClick={() => setConsent("denied")}
            sx={{
              borderColor: "#1C416A",
              color: "#1C416A",
              "&:hover": {
                borderColor: "#1C416A",
                backgroundColor: "rgba(28, 65, 106, 0.08)",
              },
            }}
          >
            {t("consent.decline")}
          </Button>
          <Button
            variant="contained"
            onClick={() => setConsent("granted")}
            sx={{
              backgroundColor: "#1C416A",
              color: "#FFFFFF",
              "&:hover": {
                backgroundColor: "#1C416A",
                opacity: 0.92,
              },
            }}
          >
            {t("consent.accept")}
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
